
const localSettings = JSON.parse(localStorage.getItem('localSettings'))

const initialState = localSettings || {
  isBarcodeReaderEnabled: false,
  isLabelPrinterEnabled: false,
  clientAppUrl: 'http://localhost:5968'
}

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isBarcodeReaderEnabled: state => state.isBarcodeReaderEnabled,
    isLabelPrinterEnabled: state => state.isLabelPrinterEnabled,
    clientAppUrl: state => state.clientAppUrl
  },
  actions: {
    updateLocalSettings ({ commit }, settings) {
      localStorage.setItem('localSettings', JSON.stringify(settings))
      commit('SET_LOCAL_SETTINGS', settings)
    }
  },
  mutations: {
    SET_LOCAL_SETTINGS (state, settings) {
      state.isBarcodeReaderEnabled = settings.isBarcodeReaderEnabled
      state.isLabelPrinterEnabled = settings.isLabelPrinterEnabled
      state.clientAppUrl = settings.clientAppUrl
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/localSettings.js